// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".device-id-cookies-iframe[data-v-1c36d09c]{width:0;height:0;visibility:hidden;position:absolute;right:-5000px}", ""]);
// Exports
module.exports = exports;
